import { Entity } from '@backstage/catalog-model';
import { INFISICAL_PROJECT_ID } from '../constants';

export const isInfisicalProjectAvailable = (entity: Entity): boolean =>
  Boolean(entity.metadata.annotations?.[INFISICAL_PROJECT_ID]);
